'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UITranslatable;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('./utils');

var _i18nContext = require('../context/i18nContext');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DISPLAY_NAME_PREFIX = 'Translatable';

/**
 * @param  {React.Component}
 * @return {string}
 */
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var propTypesWithoutI18n = function propTypesWithoutI18n(propTypes) {
  var newPropTypes = _extends({}, propTypes);
  delete newPropTypes.I18n;
  return newPropTypes;
};

/**
 * @param  {React.Component}
 * @param  {Array<string>}
 * @return {React.Component}
 */
function UITranslatable(InputComponent) {
  var controlledComponent = _react2.default.createClass({
    displayName: DISPLAY_NAME_PREFIX + '(' + getDisplayName(InputComponent) + ')',

    propTypes: propTypesWithoutI18n(InputComponent.propTypes),

    contextTypes: {
      I18n: _react.PropTypes.object
    },

    /**
     * @return {Object}
     */
    getDefaultProps: function getDefaultProps() {
      return _extends({}, InputComponent.defaultProps);
    },


    /**
     * @return {React.Element}
     */
    render: function render() {
      var _this = this;

      return _react2.default.createElement(
        _i18nContext.Consumer,
        null,
        function (i18nContext) {
          return _react2.default.createElement(InputComponent, _extends({}, _this.props, {
            ref: function ref(wrappedInstance) {
              (0, _utils.copyMethods)(wrappedInstance, _this);
            },
            I18n: i18nContext.I18n || _this.context.I18n || _I18n2.default
          }));
        }
      );
    }
  });

  (0, _utils.attachWrappedComponent)(controlledComponent, InputComponent);

  return controlledComponent;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/decorators/Translatable.js
// module id = 29
// module chunks = 0